import { initSlider } from "//koboldnest.de/cdn/shop/t/4/assets/theme.js?v=58130512527112876771708700580";

class MasonryCarousel extends HTMLElement {
  constructor() {
    super();

    const selectors = {
      parent: '.content-slideshow',
      slider: '.items-carousel',
      trigger: '.products-masonry-trigger',
      activeTrigger: '.products-masonry-trigger.active'
    };

    this.$parent = this.querySelector(selectors.parent);
    this.$slider = this.querySelector(selectors.slider);
    this.$triggers = this.querySelectorAll(selectors.trigger);
    this.$activeTrigger = this.querySelector(selectors.activeTrigger);
    this.$flickity = initSlider(this.$slider);

    this.addEvents();
  }

  addEvents() {
    this.$flickity.on('change', index => {
      const new_active = this.$parent.querySelector('[data-slide="' + index + '"]');
      if (new_active) {
        this.$activeTrigger.classList.remove('active');
        this.$activeTrigger = new_active;
        this.$activeTrigger.classList.add('active');
      }
    })

    this.$triggers.forEach( $t => {
      $t.addEventListener('click', e => {
        const targetSlide = e.currentTarget.dataset.slide;
        this.$activeTrigger.classList.remove('active');
        this.$activeTrigger = e.currentTarget;
        this.$activeTrigger.classList.add('active');

        if (typeof targetSlide !== 'undefined' && this.$flickity) {
          this.$flickity.select(targetSlide);
        }
      });
    });
  }
}
customElements.define('masonry-carousel', MasonryCarousel);
